import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { SalesTransaction } from '../../models/sales-transaction.model';
import { SalesTransactionsActions } from './sales-transactions.actions';

export interface SalesTransactionsState extends EntityState<SalesTransaction> {
  loading: boolean;
  error: string | null;
}

export const adapter = createEntityAdapter<SalesTransaction>();

const initialState: SalesTransactionsState = adapter.getInitialState({ loading: false, error: null });

export const salesTransactionsFeature = createFeature({
  name: 'salesTransactions',
  reducer: createReducer(
    initialState,
    on(SalesTransactionsActions.loadSalesTransactions, (state) => ({ ...state, loading: true, error: null })),
    on(SalesTransactionsActions.loadSalesTransactionsSuccess, (state, { transactions }) =>
      adapter.setAll(transactions, { ...state, loading: false })),
    on(SalesTransactionsActions.loadSalesTransactionsFailure, (state, { error }) => ({ ...state, loading: false, error })),
    on(SalesTransactionsActions.loadSalesTransactionSuccess, (state, { transaction }) =>
      adapter.upsertOne(transaction, state)),
    on(SalesTransactionsActions.createSalesTransactionSuccess, (state, { transaction }) =>
      adapter.addOne(transaction, state)),
    on(SalesTransactionsActions.deleteSalesTransactionSuccess, (state, { id }) =>
      adapter.removeOne(id, state)),
  )
});

export const {
  name: salesTransactionsFeatureKey,
  reducer,
  selectSalesTransactionsState,
  selectLoading: selectSalesTransactionsLoading,
  selectError: selectSalesTransactionsError,
} = salesTransactionsFeature;

export const { selectAll, selectEntities } = adapter.getSelectors();
